import { useSelector } from 'react-redux';
import { selectUserData } from '../store/slices/UserDataSlice';
import { UserData } from '../store/slices/UserDataSlice';

export const useUserData = (): UserData => {
  return useSelector(selectUserData);
};

export default useUserData;
